import { Service } from '../../../../../types/service.type';

const buildServiceMetadata = (service: Service) => {
    const metadata: Record<string, any> = {};

    if (service.code) {
        metadata['Code'] = service.code;
    }
    if (service.stripeId) {
        metadata['Stripe ID'] = true;
    }
    if (service.towingEligibilityDays && service.towingEligibilityDays >= 0) {
        metadata['Dias para grua'] = service.towingEligibilityDays;
    }
    if (service.totalFreeTowingServices) {
        metadata['Total gruas'] = service.totalFreeTowingServices;
    }
    if (service.totalFreeAmbulanceServices) {
        metadata['Total ambulancias'] = service.totalFreeAmbulanceServices;
    }
    return metadata;
};

export { buildServiceMetadata };
